import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { useInstructionStyles } from './styles';

const Instruction = ({ ...props }) => {
  const { icon, text } = props;
  const classes = useInstructionStyles();
  return (
    <Grid direction="row" container className={classes.container}>
      <Grid item xs={2}>
        {icon && <img src={icon} className={classes.image} />}
      </Grid>
      <Grid item xs={10}>
        <Typography className={classes.text}>{text}</Typography>
      </Grid>
    </Grid>
  );
};

Instruction.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
};

export default Instruction;
